import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import PlatformStatCard from "../components/PlatformStatCard";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import MRRGrowthChart from "./components/MRRGrowthChart";
import PlanDistributionChart from "./components/PlanDistributionChart";
import ClientAcquisitionChart from "./components/ClientAcquisitionChart";
import usePlatformDashboard from "./hooks/usePlatformDashboard";

const fmt = (n) => (n || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

const PlatformDashboard = () => {
    const { data, loading } = usePlatformDashboard();
    const navigate = useNavigate();

    const m = data || {};

    return (
        <div className="pb-5">
            <div className="mb-4">
                <Breadcrumb title="Dashboard" />
            </div>

            <h5 className="mb-3 mt-4 fw-bold text-dark" style={{ fontFamily: "Outfit, sans-serif" }}>Indicadores Gerais do SaaS</h5>

            <Row className="g-3 mb-4">
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-trend-up" label="MRR (Recorrência Mensal)" value={loading ? "..." : `R$ ${fmt(m.mrr)}`} color="primary" onClick={() => navigate("/platform/billing")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-chart-line" label="ARR (Recorrência Anual)" value={loading ? "..." : `R$ ${fmt(m.arr)}`} color="purple" onClick={() => navigate("/platform/billing")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-check-square" label="Receita Recebida" value={loading ? "..." : `R$ ${fmt(m.revenueReceived)}`} color="success" onClick={() => navigate("/platform/billing?status=approved")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-clock" label="Receita Pendente" value={loading ? "..." : `R$ ${fmt(m.revenuePending)}`} color="warning" onClick={() => navigate("/platform/billing?status=pending")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-buildings" label="Clientes Ativos" value={loading ? "..." : String(m.activeClients || 0)} color="primary" onClick={() => navigate("/platform/tenants?status=active")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-sparkle" label="Em Teste (Trial)" value={loading ? "..." : String(m.trialClients || 0)} color="info" onClick={() => navigate("/platform/tenants?status=trial")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-x-circle" label="Inadimplentes" value={loading ? "..." : String(m.inadimplentClients || 0)} color="danger" onClick={() => navigate("/platform/tenants?status=inadimplente")} />
                </Col>
                <Col xl={3} lg={6} md={6}>
                    <PlatformStatCard icon="ph-light ph-arrow-square-down" label="Cancelamentos (Mês)" value={loading ? "..." : `${m.cancelledClients || 0} (${m.churnRate || "0%"})`} color="warning" onClick={() => navigate("/platform/tenants?status=cancelled")} />
                </Col>
            </Row>

            <h5 className="mb-3 mt-4 fw-bold text-dark" style={{ fontFamily: "Outfit, sans-serif" }}>Análise de Faturamento e Vendas</h5>
            <Row className="g-4 mb-4">
                <Col lg={8} md={12}>
                    <MRRGrowthChart data={m.mrrHistory || []} />
                </Col>
                <Col lg={4} md={12}>
                    <PlanDistributionChart data={m.planDistribution || []} />
                </Col>
            </Row>

            <h5 className="mb-3 mt-4 fw-bold text-dark" style={{ fontFamily: "Outfit, sans-serif" }}>Crescimento e Retenção de Clientes</h5>
            <Row className="g-4 mb-4">
                <Col lg={12}>
                    <ClientAcquisitionChart data={m.clientAcquisition || []} />
                </Col>
            </Row>
        </div>
    );
};

export default PlatformDashboard;
